import * as tslib_1 from "tslib";
import * as React from 'react';
import * as _ from 'lodash';
import { applyTheme } from './styleUtils';
var WixStyle = /** @class */ (function (_super) {
    tslib_1.__extends(WixStyle, _super);
    function WixStyle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WixStyle.prototype.render = function () {
        var _a = this.props, _b = _a.styleParams, styleParams = _b === void 0 ? { colors: '', fonts: '', numbers: '' } : _b, children = _a.children;
        _.set(styleParams, 'colors', _.get(styleParams, 'styleParams.colors'));
        _.set(styleParams, 'fonts', _.get(styleParams, 'styleParams.fonts'));
        _.set(styleParams, 'numbers', _.get(styleParams, 'styleParams.numbers'));
        var style = styleParams ? applyTheme(children, styleParams) : children;
        return React.createElement("style", null, style);
    };
    return WixStyle;
}(React.Component));
export { WixStyle };
//# sourceMappingURL=WixStyle.js.map